<template>
    <div class="papsi-wrapper">
        <h1 class="text-2xl font-semibold text-[#24723b]">Signatories for Consideration Form</h1>
        <p class="text-xs text-[#747474] mt-2">Home / Form Signatories</p>
    </div>
    <div class="flex flex-col gap-6 mt-11 bg-[#f0f0f0] border-[#ffffff41] border-[3px] p-3 rounded-md shadow">
        <div class="flex gap-5">
            <div class="w-full">
                <label class="text-sm">Office/Division</label>
                <select class="w-full border-2 border-[#afafaf] p-2 py-3 text-sm rounded-md" @change="onchangedivision" v-model="vdivision">
                    <option disabled selected value="">Please select Office/Division</option>
                    <option v-for="(row , index) in division" :key="index" :value="row.fdiv_key">{{ row.fdiv_desc }}</option>
                </select>
            </div>
            <div class="w-full">
                <label class="text-sm">Department</label>
                <select class="w-full border-2 border-[#afafaf] p-2 py-3 text-sm rounded-md" v-model="vdepartment" @change="onchangedepartment">
                    <option disabled selected value="">Please select Department</option>
                    <option v-for="(row , index) in info" :key="index" :value="row.fdept_key">{{ row.fdept_desc }}</option>
                </select>
            </div>
        </div>
        <div class="flex gap-5">
            <div class="w-full">
                <label class="text-sm">Section</label>
                <select class="w-full border-2 border-[#afafaf] p-2 py-3 text-sm rounded-md" v-model="vsection">
                    <option disabled selected value="">Please select Section</option>
                    <option v-for="(row , index) in section" :key="index" :value="row.fsec_key">{{ row.fsec_desc }}</option>
                </select>
            </div>
            <div class="w-full">
                <label class="text-sm">Category</label>
                <select class="w-full border-2 border-[#afafaf] p-2 py-3 text-sm rounded-md">
                    <option value="RANK AND FILE"> RANK AND FILE  </option>
                    <option value="SUPERVISOR">    SUPERVISOR     </option>
                    <option value="MANAGER">       MANAGER        </option>
                    <option value="TOP MANAGEMENT">TOP MANAGEMENT </option>
                </select>
            </div>
        </div>
    </div>
    <div class="pt-6 mt-11 border-t border-[#ccc4c4] bg-[#f0f0f0] border-[#ffffff41] border-[3px] p-3 rounded-md shadow px-5">
            <h1 class="font-semibold text-[#24723b]">Digital Signatories</h1>
            <div class="flex gap-5 mt-6">
                <div class="w-full">
                    <label class="text-sm">Immediate Superior(Recommendation)</label>
                    <select class="w-full border-2 border-[#afafaf] p-2 py-3 text-sm rounded-md" v-model="SuperiorKey">
                        <option  class="text-[#6d6c6c]" selected disabled value="">Immediate Superior(Recommendation)</option>
                        <option v-for="(row , index) in GetName" :key="index" :value="row.femp_key" >{{ row.ff_name + " " + row.fm_name + " " + row.fl_name }}</option>
                    </select>
                </div>
                <div class="w-full">
                    <label class="text-sm" >Division/Office Executive (Approval)</label>
                    <select class="w-full border-2 border-[#afafaf] p-2 py-3 text-sm rounded-md" v-model="ExecutiveKey">
                        <option  class="text-[#6d6c6c]" selected disabled value="">Division/Office Executive (Approval)</option>
                        <option v-for="(row , index) in GetName" :key="index" :value="row.femp_key" >{{ row.fa_name }}</option>
                    </select>
                </div>
            </div>
            <div class="flex justify-center mt-11">
                <button class="w-[190px] text-white bg-[#24723b] p-2 rounded-md">Update Signatory</button>
            </div>
            <div class="pt-6 mt-11 border-t border-[#ccc4c4]">
                <h1 class="font-semibold text-[#24723b]">Current Form Signatories</h1>
                <div class="flex gap-5 mt-6">
                    <div class="w-full">
                        <label class="text-sm">Immediate Superior(Recommendation)</label>
                        <p>LHAN ZELL REYES</p>
                    </div>
                    <div class="w-full">
                        <label class="text-sm" >Division/Office Executive (Approval)</label>
                        <p>LHAN ZELL REYES</p>
                    </div>
                </div>
            </div>
            
    </div>
</template>


<script>
import axios from "axios";
import { defineComponent } from "vue";

export default defineComponent({
    data(){
        return{
            division:       '',
            vdivision:      '',
            info:           '',
            vdepartment:    '',
            section:        '',
            vsection:       '',
            GetName:        '',     //GET NAME AND EMP_ID
            SuperiorKey:    '',     
            ExecutiveKey:   '',
        }
    },
    mounted(){
        this.getAllDivision();
        this.getName();
        },
    methods:{
        onchangedivision(){
            axios.request({
            method: "GET",
            url:'http://127.0.0.1:8000/api/v1/ohr/GetDepartment/'+ this.vdivision})
            .then(response => (
                this.vdepartment = '',
                this.vsection = '',
                this.section = '',
                this.info = response.data.data
            ))
        },
        getName(){
            axios.request({
            method: "GET",
            url:'http://127.0.0.1:8000/api/v1/ohr/Employee-name'})
            .then(response => (
                this.GetName = response.data.data
            ))

        },
        onchangedepartment(){
            axios.request({
            method: "GET",
            url:'http://127.0.0.1:8000/api/v1/ohr/GetSection/'+ this.vdepartment})
            .then(response => (
                this.vsection =                    '',
                this.section  =                    '',
                this.section  = response.data.data
            ))
        },
        getAllDivision(){
            axios.request({
            method: "GET",
            url:'http://127.0.0.1:8000/api/v1/ohr/GetallDivision'})
            .then(response => (
                this.division = response.data.data
            ))
        },
    }
})


</script>